import { Injectable } from '@angular/core';
import { NgxPermissionsService, NgxRolesService } from 'ngx-permissions';
import { User } from '../config';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class UserService {

  private user: User;

  public myRole: string = '';

  public myPermissions: string[] = [];

  constructor(
    private rolesSrv: NgxRolesService,
    private permissionsSrv: NgxPermissionsService,
    private http: HttpClient
  ) {
  }

  async getMyUser() {
    const token = localStorage.getItem('BearerToken');
    const userStr = localStorage.getItem('user');
    if (userStr) {
      this.user = JSON.parse(userStr);
    }
    //await this.http.get(`${this.apiUrl}/user`).toPromise()
    return this.user;
  }

  setMyUser(myUser: User) {
    localStorage.setItem('user', JSON.stringify(myUser));
    this.user = myUser;
  }

  getMyRole() {
    return this.user?.role || '';
  }

  setMyRole(myRole: string) {
    if (this.user) {
      this.user.role = myRole as any;
    }
  }

  getMyPermissions() {
    return this.user?.permissions || [];
  }

  setMyPermissions(myPermissions: string[]) {
    if (this.user) {
      this.user.permissions = myPermissions;
    }
  }

  // NOVO: Métodos para verificar tipo de utilizador
  isClient(): boolean {
    return this.user?.user_type === 'client';
  }

  isUser(): boolean {
    return this.user?.user_type === 'user';
  }

  isAdmin(): boolean {
    return this.isUser() && (this.user?.is_admin === true || this.user?.admin === true);
  }

  /** Clientes que são admins da brand (veem todos os serviços da brand). */
  isBrandAdmin(): boolean {
    return this.user?.user_type === 'client' && (this.user as any).is_brand_admin === true;
  }

  /**
   * "Super cliente" (admin Armindohub): cliente global read-only que vê o que os clientes veem
   * em TODAS as marcas. Lê de `this.user` com fallback a localStorage, porque algumas vistas
   * públicas (embed de aprovação) podem renderizar antes de `getMyUser()` correr.
   * Ver docs/BACKEND-SUPER-CLIENT-GLOBAL-VIEWER-2026-06-08.md.
   */
  isSuperClient(): boolean {
    if (this.user) {
      return this.user.user_type === 'client' && (this.user as any).is_super_client === true;
    }
    try {
      const u = JSON.parse(localStorage.getItem('user') || '{}');
      return u?.user_type === 'client' && u?.is_super_client === true;
    } catch {
      return false;
    }
  }

  getClientId(): number | null {
    return (this.user as any)?.client_id ?? null;
  }

  getBrandId(): number | null {
    return (this.user as any)?.brand_id ?? null;
  }

  getUserType(): 'user' | 'client' | null {
    return this.user?.user_type || null;
  }

  savePermissions() {
    if (!this.user) return;
    
    this.rolesSrv.flushRolesAndPermissions();
    const role = this.user.role || '';
    const permissions = this.user.permissions || [];
    
    if (role) {
      this.rolesSrv.addRoleWithPermissions(role, permissions);
    }
    this.permissionsSrv.flushPermissions();
    if (permissions.length > 0) {
      this.permissionsSrv.addPermission(permissions);
    }
  }

  updateAllPermissions(myRole: string, myPermissions: string[]) {
    this.setMyRole(myRole);
    this.setMyPermissions(myPermissions);
    this.savePermissions();
  }

  async sendUserInvite(invite: any) {
    let data: any = await this.http.post(`${environment.url}/api/users/invite`, invite).toPromise()
    return data;
  }
  async getUserInvite(inviteId: any) {
    let data: any = await this.http.get(`${environment.url}/api/users/invite?token=` + inviteId).toPromise()
    return data;
  }
  async getAllUsers() {
    let data: any = await this.http.get(`${environment.url}/api/users`).toPromise()
    return data;
  }
  async setUserInvitePassword(inviteUserPassword: any) {
    let data: any = await this.http.post(`${environment.url}/api/users/invite/accept`, inviteUserPassword).toPromise()
    return data;
  }
  async deleteUser(idUser: any) {
    let data: any = await this.http.delete(`${environment.url}/api/users?id=` + idUser).toPromise()
    return data;
  }
  async updateUserBoards(user: any) {
    let data: any = await this.http.put(`${environment.url}/api/users/boards`, user).toPromise()
    return data;
  }
  async setUserTheme(userTheme: any) {
    let data: any = await this.http.put(`${environment.url}/api/users/theme`, userTheme).toPromise()
    return data;
  }
}
